<template>
  <div class="fromStyle">
    <a-form :form="form" @submit="handleSubmit">
      <a-form-item label="岗位名称" v-bind="formItemLayout">
        <a-select
          mode="multiple"
          showSearch
          optionFilterProp="children"
          v-decorator="[
            'role_id_list',
            { rules: [{ required: true, message: '请选择岗位名称!' }] }
          ]"
          placeholder="请选择岗位名称"
        >
          <a-select-option
            v-for="(item, i) in roleList"
            :key="i"
            :value="item.id"
            >{{ item.role_name }}</a-select-option
          >
        </a-select>
      </a-form-item>
      <a-form-item label="标题" v-bind="formItemLayout">
        <a-input
          v-decorator="[
            'title',
            { rules: [{ required: true, message: '请填写消息标题!' }] }
          ]"
        />
      </a-form-item>
      <a-form-item label="内容" v-bind="formItemLayout">
        <a-textarea
          v-decorator="[
            'content',
            { rules: [{ required: true, message: '请填写消息内容!' }] }
          ]"
        />
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
        <a-button type="primary" html-type="submit">提交</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import axios from "axios";
export default {
  inject: ["reload"],
  data() {
    return {
      formLayout: "horizontal",
      form: this.$form.createForm(this),
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 12 }
      },
      roleList: []
    };
  },
  mounted() {
    this.getRoleList(); //获取岗位列表
  },
  methods: {
    getRoleList() {
      const url = this.httpsBasic.url + this.httpsBasic.user + "User/roleList";
      const pramas = {
        token: window.localStorage.getItem("xnwfPcToken"),
        per_page: 100000,
        role_type: 1
      };
      axios
        .post(url, pramas)
        .then(res => {
          // console.log(res);
          if (res.data.code == 200) {
            this.roleList = res.data.data.data;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
        });
    },
    handleSubmit(e) {
      e.preventDefault();
      //   console.log(this.$store.state.token)
      this.form.validateFields((err, pramas) => {
        //   console.log(pramas)
        if (!err) {
          let url =
            this.httpsBasic.url +
            this.httpsBasic.message +
            "Message/sendSystemMessageToRole";
          let params = {
            role_id_list: pramas.role_id_list,
            title: pramas.title,
            content: pramas.content,
            token: window.localStorage.getItem("xnwfPcToken")
          };
          //   console.log(params)
          axios
            .post(url, params)
            .then(res => {
              if (res.data.code == 200) {
                this.$message.success("提交成功");
                this.$emit("hideInSend", false);
              } else {
                this.$message.warning(res.data.message);
              }
            })
            .catch(err => {
              this.$message.error("服务器出错了...");
            });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.fromStyle {
  margin: 12% 4%;
}
</style>
